<template>
  <input
    v-if="edit"
    ref="input"
    v-model="localValue"
    type="text"
    :class="style.input"
    @click.stop
    @mousedown.stop
    @keydown.enter.prevent="save"
    @keydown.esc.prevent="cancel"
    @blur="save"
  />

  <h4 v-else :class="style.text">
    <slot>{{ modelValue }}</slot>
  </h4>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "./SectionHeaderEditable.module.scss";

export default defineComponent({
  name: "SectionHeaderEditable",
  emits: ["update:modelValue", "save", "cancel"],
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      style,
      localValue: this.modelValue
    };
  },
  mounted() {
    if (this.edit) {
      this.focusInput();
    }
  },
  methods: {
    save(): void {
      this.$emit("update:modelValue", this.localValue);
      this.$emit("save", this.localValue);
    },

    cancel(): void {
      this.localValue = this.modelValue;
      this.$emit("cancel");
    },

    focusInput() {
      this.$nextTick(() => {
        const input = this.$refs.input as HTMLInputElement | undefined;

        if (!input) {
          return;
        }

        input.focus();
        input.select();
      });
    }
  },
  watch: {
    modelValue(value: string) {
      this.localValue = value;
    },

    edit(value: boolean) {
      if (value) {
        this.localValue = this.modelValue;
        this.focusInput();
      }
    }
  }
});
</script>
